import { render, staticRenderFns } from "./MusicControl-v2.vue?vue&type=template&id=4d017cb8&scoped=true"
import script from "./MusicControl-v2.vue?vue&type=script&lang=js"
export * from "./MusicControl-v2.vue?vue&type=script&lang=js"
import style0 from "./MusicControl-v2.vue?vue&type=style&index=0&id=4d017cb8&prod&lang=less"
import style1 from "./MusicControl-v2.vue?vue&type=style&index=1&id=4d017cb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d017cb8",
  null
  
)

export default component.exports